export class StoreCurrentAutoCaseConfig {
  static readonly type = '[Auto Cases] Store Current Congif';
  constructor(public customerId: string) {}
}
